<template>
  <div class="externalPaymentForm">
    <div v-if="financingEnabled">
      <div class="d-flex align-items-center mb-2">
        <strong class="mr-3">Payment Type</strong>
        <RadioGroup
          v-model="paymentType"
          data-cy="paymentTypeSelector"
          horizontal
          :options="[
            { subtitle: 'Other', value: 'other' },
            { subtitle: 'Financing', value: 'financing' }
          ]"
        />
      </div>
    </div>
    <ExternalOtherForm
      v-if="paymentType === 'other'"
      ref="paymentForm"
      data-cy="otherForm"
    />
    <ExternalFinancingForm
      v-if="paymentType === 'financing'"
      ref="paymentForm"
      data-cy="financingForm"
      :invoice-id="invoiceId"
      :payment-amount-cents="paymentAmountCents"
    />
  </div>
</template>

<script lang="ts" setup>
import { ref, watch } from "vue";

import RadioGroup from "@/components/RadioGroup.vue";
import ExternalFinancingForm from "./external/ExternalFinancingForm.vue";
import ExternalOtherForm from "./external/ExternalOtherForm.vue";

defineProps({
  paymentAmountCents: {
    type: Number,
    default: () => 0
  },
  invoiceId: {
    type: Number,
    default: null
  },
  financingEnabled: {
    type: Boolean,
    default: false
  }
});
const emit = defineEmits(["update:payment-type"]);

const paymentForm = ref<any>(null);
const paymentType = ref<"other" | "financing">("other");

async function validate() {
  await paymentForm.value.validate();
}

async function getData() {
  await validate();
  return paymentForm.value.getData();
}

defineExpose({ validate, getData });

watch(
  paymentType,
  (val) => {
    emit("update:payment-type", val);
  },
  { immediate: true }
);
</script>
